import { useEffect, useState } from "react";

const useOverflow = (ref: React.RefObject<HTMLElement>) => {
  // States definition
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    // Get the current element
    const el = ref.current;
    if (!el) return;

    // Check overflow function definition
    const checkOverflow = () => {
      setIsOverflowing(
        el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth,
      );
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, [ref]);

  return isOverflowing;
};

export default useOverflow;
